import { atom } from 'recoil';

export const participationStateRecoil = atom<number>({
  key: 'participationStateRecoil',
  default: 0,
});
